import { QUESTION_TYPES } from '@/components/Blocks/BlockTestOrQuiz/constants.js';

export const ACCEPT_FILE_IMPORT_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
];

export const QUESTION_TYPES_WITH_DISABLED_CONDITION_AND = [QUESTION_TYPES.SINGLE_CHOICE, QUESTION_TYPES.QUIZ_CARDS];
